import React from "react";
import { Button as MuiButtonV4, ButtonProps } from "@material-ui/core";

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ children, style = {}, ...props }, ref) => {
        const defaultStyle = { borderRadius: "25px" };
        const combinedStyle = { ...defaultStyle, ...style };

        return (
            <MuiButtonV4 {...props} style={combinedStyle} ref={ref}>
                {children}
            </MuiButtonV4>
        );
    }
);

Button.displayName = "Button";
